/**
 * Browser tab titles. Home is the punter night-out page; comedian signup is /apply.
 * @see docs/APP_UI_SPEC.md — G1
 */

const BRAND = 'Hilarity Unlimited';

const TITLE_BY_ROUTE = {
  Home: BRAND,
  Apply: `Apply to perform — ${BRAND}`,
  ForVenues: `Comedy night management — ${BRAND}`,
  Sunset: `Sunset Comedy — ${BRAND}`,
  Craicup: `Craic-Up Comedy — ${BRAND}`,
  Studio48: `Studio 48 — ${BRAND}`,
  Legacy: `Events — ${BRAND}`,
  Admin: `Admin — ${BRAND}`,
  AdminComics: `Comics — ${BRAND}`,
  AdminDates: `Dates — ${BRAND}`,
  AdminRota: `Rota — ${BRAND}`,
  AdminInbox: `Inbox — ${BRAND}`,
  AdminClubs: `Clubs — ${BRAND}`,
};

export function documentTitleForRoute(route) {
  const name = route?.name;
  return TITLE_BY_ROUTE[name] || BRAND;
}

export function applyDocumentTitle(route) {
  if (typeof document === 'undefined') return;
  document.title = documentTitleForRoute(route);
}

/** Nights added from Clubs have no named route. Set the tab once the venue row loads. */
export function applyVenueNightTitle(venueName) {
  if (typeof document === 'undefined') return;
  const name = String(venueName || '').trim();
  document.title = name ? `${name} — ${BRAND}` : BRAND;
}
